/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Rapat_NInputs */

const en_tut_rapat_n = /** @type {(inputs: Tut_Rapat_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Limits: 15 people per room, 2 rooms active at once, 4 hours per meeting. Notes, agenda, and transcript are kept for 90 days after the meeting ends — the host may delete them sooner. Automatic transcripts can be wrong; check names, numbers, and decisions before relying on them.`)
};

const id_tut_rapat_n = /** @type {(inputs: Tut_Rapat_NInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batasnya: 15 orang per ruang, 2 ruang aktif bersamaan, dan 4 jam per rapat. Catatan, agenda, dan transkrip disimpan 90 hari setelah rapat selesai — host boleh menghapusnya lebih awal. Transkrip otomatis bisa keliru; periksa nama, angka, dan keputusan sebelum dipakai.`)
};

/**
* | output |
* | --- |
* | "Limits: 15 people per room, 2 rooms active at once, 4 hours per meeting. Notes, agenda, and transcript are kept for 90 days after the meeting ends — the host..." |
*
* @param {Tut_Rapat_NInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_rapat_n = /** @type {((inputs?: Tut_Rapat_NInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Rapat_NInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_rapat_n(inputs)
	return en_tut_rapat_n(inputs)
});